import React from 'react'
import "./Timeline.css"
import AnimateOnScroll from '../../components/ScrollAnimations/AnimateOnScroll'


const steps = [
                {
                    section: "Discovery",
                    title: "Understanding Your Business",
                    description:
                    "We explore your brand, product, audience, and goals to uncover what users need and what's holding them back. These insights shape a performance-driven design strategy.",
                    // current: true,
                    side: "right",
                },
                {
                    section: "Strategy Development",
                    title: "Crafting the Conversion Plan",
                    description:
                    "We design a structure that flows, persuades, and converts. From layout and copy hierarchy to UX flow and wireframes, everything is rooted in conversion psychology.",
                    // current: false,
                    side: "left",
                },
                {
                    section: "Implementation",
                    title: "Designing With Precision",
                    description: "We bring your brand to life through stunning, conversion-optimized visuals. Built in Figma or Webflow, every section is designed to guide users toward action.",
                    // current: false,
                    side: "right",
                },
                {
                    section: "Monitoring & Optimization",
                    title: "Launching and Learning",
                    description: "Once your site is live, we track how users interact with it. Using scroll maps, click data, and session recordings, we identify friction and continuously refine the experience.",
                    // current: false,
                    side: "left",
                },
                {
                    section: "Reporting & Communication",
                    title: "Transparent Progress Always",
                    description: "You'll always know what's happening. We share regular updates, performance snapshots, and walkthroughs that keep you informed and in control.",
                    // current: false,
                    side: "right",
                },
                {
                    section: "Review & Adapt",
                    title: "Scaling What Works",
                    description: "As your business evolves, so should your site. We help adapt your design to support new products, funnels, and growth opportunities.",
                    // current: false,
                    side: "left",
                },
            ];

const Timeline = () => {
return (
    <section className="timeline-section">
      <h2 className="timeline-heading">
        Our Approach to Your <span className="highlight">Success</span>
      </h2>
<AnimateOnScroll delay={0.5} animationClass="fade-in-up" baseClass="timeline-animation">
      <div className="timeline-container">
        <div className="timeline-line"></div>

        {steps.map((step, idx) => (
          <div key={idx}>
            

            <div
              className={`timeline-step ${step.side === "left" ? "left" : "right"}`}
            >
            {/* Section Label if exists */}
            {step.section && (
              
              <div className="timeline-phase-label">{step.section}</div>

            )}
              <div className="timeline-dot"></div>

              {/* <div className={`timeline-card ${step.current ? "current" : ""}`}> */}
              <div className={`timeline-card`}>
                {step.current && (
                  <div className="current-label">We are here</div>
                )}
                <h3>{step.title}</h3>
                {step.description && <p>{step.description}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
      </AnimateOnScroll>
    </section>
)
}

export default Timeline